import { create } from 'zustand';

import { createInputSlice, type InputSlice } from './slices/input.slice';
import {
  createNavigationSlice,
  type NavigationSlice,
} from './slices/navigation.slice';

// Combined store type
export type SetupStore = InputSlice & NavigationSlice;

// Create the combined store using slices
export const useSetupStore = create<SetupStore>()((...a) => ({
  ...createInputSlice(...a),
  ...createNavigationSlice(...a),
}));
